import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = () => {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/signin" replace />;
  return <Outlet />;
};

export default PrivateRoute;
